import React, { Component } from 'react';
import ReactIScroll from 'react-iscroll';
var iScroll = require('iscroll/build/iscroll-probe')
import { connect } from 'react-redux';
import _ from 'lodash';
import { checkData, shallowEqual } from '../../../utils/shared.js';
import { donorsIncluded } from '../../../utils/donorHelpers';
import { getFileType, videoType } from '../../../utils/fileHelpers';
import LinkListChicago from './LinkListChicago';
import CircleImageInfoBlock from '../../General/CircleImageInfoBlock';
import InfoBlock from '../../General/InfoBlock';
import StoryChicagoModal from './StoryChicagoModal'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import shared from '../../../utils/shared.js'

const config = {
	showTitle: true,
	showName: true,
	showSubheader: false,
	columns: 2,
	cycle_all_groups: true
}

class DonorListChicago extends Component {


	constructor(props) {
		super(props);

		this.state = {
			donorsGrouped: [],
			selectedLinkIndex: 0,
			showStory: false,
			story: {
				contextualheader: null,
				headline: null,
				subtitle: null,
				body: null,
				quote: null,
				mainimage: null,
				id: null,
				slickAssets: null
			},
			initializedRefs: false
		}
		this.refDict = [];
		this.scrollRef = {};

		// this._fontClass = null;
		// if (_.has(this.props.module.contents, 'custom_fields.override_font_family')) {
		// 	if (this.props.module.contents.custom_fields.override_font_family.val) {
		// 		this._fontClass = this.props.module.contents.custom_fields.font_family.val.value;
		// 	}
		// }

		this._fontClass=_.get(this.props, 'module.contents.custom_fields.font_family.val.value', null);

		let titleFont = this._fontClass ? null : "aleo-bolditalic";
		this._titleStyle = {
			fontFamily: titleFont,
			fontSize: this.props.screen.r16_9.p10,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}
		this._titleHorizontalRule = {
			width: '89.5%',
			height: this.props.screen.r16_9.p10 * 0.15,
			backgroundColor: '#223954',
			display: 'inline-block',
			position: 'absolute',
			top: this.props.screen.r16_9.p10 * 1.25,
			left: 0,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}

		let subheaderFont = this._fontClass ? null : "ostrich-medium";
		this._subheaderStyle = {
			fontFamily: subheaderFont,
			fontSize: this.props.screen.r16_9.p10 * 0.5,
			marginLeft: this.props.screen.r16_9.p10 * 0.7,
		}
		this._titleSpacer = {
			width: '100%',
			height: this.props.screen.r16_9.p10 * 0.3,
			display: 'inline-block'
		}

		this._avatarList = {
			width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
			height: this.props.screen.r16_9.height,
		}

		// Check for fonts attached to the module.
		// if (_.has(this.props.module.contents, "custom_fields.font_family")) {

		// }

		this._donorGroupIndex = 0;
		this._selectDonorId = 0;
		this.donorRefs = [];
		this._refCounter = 0;
		this._donorRowHeight = 0;

	}

	componentWillMount() {
		checkData(this.props.module);
	}

	componentWillUnmount() {
		for (let a = 0; a < this.donorRefs.length; a++) {
			//let count = 0;
			if (this.donorRefs[a].el) {
				this.donorRefs[a].el.removeEventListener("tap", () => this.handleTap(this.donorRefs[a].data));
				//count++;
			}
		}
	}

	componentDidMount() {
		this.prepareDonors();
	}

	shouldComponentUpdate(prevProps, prevState) {
		if (shallowEqual(this.state, prevState)) {
			return false;
		}
		return true;
	}

	handleTap = (data) => {
		this.handleDonorClick(data.innerrow, data.donorGroupIndex);
	}

	prepareDonors = () => {
		this.setState({
			donorsGrouped: donorsIncluded(this.props.donors.donorCategories, this.props.module.contents.include_categories)
		})
	}

	switchCategory = (ref) => {
		this.setState({
			selectedLinkIndex: ref
		})
		this.scrollRef[0].withIScroll((iScroll) => {
			iScroll.disable();
			iScroll.enable();
			iScroll.scrollToElement(this.refDict[ref], 500, 0, 0, false) //-this.props.screen.r16_9.p10
		})
	}

	onScrollEnd = (e) => {
		this.props.resume();
		let selectedLinkIndex = 0;
		//select the last element that is scrolled past screen top
		for (var i = 0; i < this.refDict.length; i++) {
			let eY = this.refDict[i].getBoundingClientRect().top;
			if (eY <= 5) {
				selectedLinkIndex = i; //this is the category link on the left being selected when at or above top ofscreen 0
			}
		}

		// Check if there are more than 1 categories
		let currentCategoryHeight = this.refDict[selectedLinkIndex].clientHeight;
		let currentEy = Math.abs(this.refDict[selectedLinkIndex].getBoundingClientRect().top);

		if (this.refDict.length > 0) {
			// If current visible category has more than two donors, change left link
			// in between the two categories.
			if (this.state.donorsGrouped[selectedLinkIndex].donors.length > 2) {
				if (currentEy > currentCategoryHeight - (this._donorRowHeight * 2)) {
					selectedLinkIndex++;
				}
			}
		}

		if (this.state.selectedLinkIndex !== selectedLinkIndex) {
			this.setState({
				selectedLinkIndex: selectedLinkIndex
			})
		}

	}

	initializeDonorRefs = () => {
		if (this.state.initializedRefs === false) {
			if (this.donorRefs.length>0){
				this._donorRowHeight = this.donorRefs[0].el.clientHeight;
				for (let a = 0; a < this.donorRefs.length; a++) {
					this.donorRefs[a].el.addEventListener("tap", () => this.handleTap(this.donorRefs[a].data));
				}
				this.setState({
					initializedRefs: true
				})
			}
		}
	}

	renderDonors = (donors, donorGroupIndex) => {
		let fData = {
			unit: (this._avatarList.width * 0.12) / config.columns,
			counter: 0,
			h_spacing: this._avatarList.width / config.columns - this._avatarList.width * .025,
			v_spacing: this._avatarList.height / this.state.donorsGrouped[0].donors.length / config.columns
		}

		let donorGroupRow = [];
		let rowCounter = 0;

		for (var i = 0; i < donors.length; i++) {
			if (!donorGroupRow[rowCounter]) {
				donorGroupRow[rowCounter] = [];
			}
			donorGroupRow[rowCounter].push(donors[i]);
			if ((i + 1) % config.columns === 0) {
				rowCounter++;
			};
		}

		return (
			donorGroupRow.map(function (row, i) {
				return (
					<span key={i}>
						{this.renderDonorRow(row, i, fData, donorGroupIndex)}
					</span>
				)
			}, this)
		)

	}

	padLastCategory = (category) => {
		//logic to check numbe rof names and add padding if < 8 and add the right amount for instance 6 names needs less padding then 2.
		//multiple of this.props.screen.r16_9.p10 for height of a single cell.

		let padding = 0;
		if (category.donors.length < 7) {
			padding = this._donorRowHeight;
		}

		if (category.donors.length < 5) {
			padding = this._donorRowHeight * 2
		}

		if (category.donors.length < 3) {
			padding = this._donorRowHeight * 3;
		}

		return (
			<div style={{ width: '100%', height: padding + 'px' }}>
			</div>
		)
	}

	renderDonorCategories = () => {
		return (
			this.state.donorsGrouped.map(function (row, i) {
				return (
					<div className={this._fontClass} ref={el => this.refDict[i] = el} key={i}>
						{(i === 0 && config.showTitle) ?
							<span style={{ display: "inline-block", height: this._titleHorizontalRule.top + this._titleHorizontalRule.height }}>
								<span style={this._titleStyle}>{this.props.module.contents.headline ? this.props.module.contents.headline : <span>Donors</span>}</span>
								<span style={this._titleHorizontalRule} />
							</span>
							: <span />}
						{config.showName ?
							<div style={this._subheaderStyle}>
								<span style={this._titleSpacer} />
								<span style={{ letterSpacing: 2 }}><b>{row.name}</b></span>
								<span style={this._titleSpacer} />
							</div>
							: <span />}
						{config.showSubheader ? <div>{row.subheader}</div> : <span />}
						{this.renderDonors(row.donors, i)}
						{(i === this.state.donorsGrouped.length - 1) && (this.state.donorsGrouped.length > 1) ?
							this.padLastCategory(row) :
							null
						}
					</div>
				)
			}, this)
		)
	}

	renderDonorRow = (row, i, fData, donorGroupIndex) => {
		return (
			row.map(function (innerrow, ii) {
				let desc = "";
				let iref = null;
				if (_.has(innerrow, 'contents.texts[0].text')) {
					desc = innerrow.contents.texts[0].text
				}
				if (_.has(innerrow, 'contents.images[0]')) {
					iref = innerrow.contents.images[0];
				}
				return (
					<div className={this._fontClass} ref={el => this.donorRefs[this._refCounter++] = { el: el, data: { innerrow: innerrow, donorGroupIndex: donorGroupIndex } }} style={{ marginTop: this.props.screen.r16_9.p10 * .3, display: 'inline-block', width: fData.h_spacing }} key={ii}>
						<span style={{ width: this.props.screen.r16_9.p10 * 0.7, display: "inline-block" }} />
						<InfoBlock unit={fData.unit} header={innerrow.name} text={desc} headerColor={'#223954'} fontClass={this._fontClass} />
						<CircleImageInfoBlock mode={this.props.screen.mode} webkey={this.props.screen.webkey} image={iref} size={fData.unit * 2} screen={this.props.screen} name={innerrow.name} />
					</div>
				)
			}, this)
		)
	}

	closeStory = () => {
		this.props.toggleShowClock(true);
		this.setState({
			showStory: false,
			story: {
				id: -1
			}
		})
	}

	handleDonorClick = (data, donorGroupIndex) => {

		let slickAssets = [];
		for (var i = 0; i < data.contents.images.length; i++) {
			if (data.contents.images[i]) {
				let fileType = getFileType(data.contents.images[i].file_name);
				let vType = null;
				if (fileType === "Video") {
					vType = videoType(data.contents.images[i].file_name);
				}
				slickAssets.push({ fileType: fileType, videoType: vType, path: shared.dpath(this.props.screen.mode, data.contents.images[i].path, data.contents.images[i].file_name, this.props.screen.webkey) })
			}
		}
		//first image is thumbnail unless only one image
		if (slickAssets.length >= 2) {
			slickAssets = slickAssets.slice(1)
		}
		this._donorGroupIndex = donorGroupIndex;
		this._selectDonorId = data.id;
		if (_.has(data, 'contents.showDetails') && data.contents.showDetails === true) {
			let mainimage = "img/ui/image_default.png" //"url(img/ui/image_default.png"
			if (data.contents && data.contents.images[1]) {
				mainimage = shared.dpath(this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, this.props.screen.webkey)//"url(" + shared.dpath(this.props.screen.mode, data.contents.images[1].path, data.contents.images[1].file_name, this.props.screen.webkey) + ")";
			}
			else if (data.contents && data.contents.images[0]) {
				mainimage = shared.dpath(this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, this.props.screen.webkey)//"url(" + shared.dpath(this.props.screen.mode, data.contents.images[0].path, data.contents.images[0].file_name, this.props.screen.webkey) + ")";
			}
			let showQuotes = false;
			if (_.has(data, 'contents.custom_fields.show_quotes.val')) {
				showQuotes = data.contents.custom_fields.show_quotes.val
			}
			this.props.toggleShowClock(false);
			this.setState({
				showStory: true,
				story: {
					contextualheader: this.state.donorsGrouped[this._donorGroupIndex].name,//this.props.module.contents.headline,
					headline: data.name,//_.has(data, 'contents.texts[1].text') ? data.contents.texts[1].text : "",
					subtitle: _.has(data, 'contents.texts[0].text') ? data.contents.texts[0].text : "",
					body: _.has(data, 'contents.texts[1].text') ? data.contents.texts[1].text : "",
					quote: _.has(data, 'contents.texts[2].text') ? data.contents.texts[2].text : "",
					mainimage: mainimage,
					id: data.id ? data.id : "",
					slickAssets: slickAssets,
					showQuotes: showQuotes
				}
			})
		}
	}

	cycleStory = (direction) => {
		let donorSelect = _.findIndex(this.state.donorsGrouped[this._donorGroupIndex].donors, { id: this._selectDonorId });
		if (donorSelect !== undefined) {

			if (direction === "forward") {
				donorSelect++;
				if (donorSelect >= this.state.donorsGrouped[this._donorGroupIndex].donors.length) {
					donorSelect = 0;
					//cycle group
					if (config.cycle_all_groups === true) {
						this._donorGroupIndex++;
						if (this._donorGroupIndex >= this.state.donorsGrouped.length) {
							this._donorGroupIndex = 0;
						}
					}
				}
			}
			else {
				donorSelect--;
				if (donorSelect < 0) {
					if (config.cycle_all_groups === true) {
						this._donorGroupIndex--;
						if (this._donorGroupIndex < 0) {
							this._donorGroupIndex = this.state.donorsGrouped.length - 1
						}
					}
					donorSelect = this.state.donorsGrouped[this._donorGroupIndex].donors.length - 1;
				}
			}
			let newDonor = this.state.donorsGrouped[this._donorGroupIndex].donors[donorSelect];
			this._selectDonorId = newDonor.id;

			if (_.has(newDonor, 'contents.showDetails')) {
				if (this.state.donorsGrouped[this._donorGroupIndex].donors[donorSelect].contents.showDetails === true) {
					this.handleDonorClick(this.state.donorsGrouped[this._donorGroupIndex].donors[donorSelect], this._donorGroupIndex);
					return;
				}
			}
			this.cycleStory(direction);
		}

	}

	navarea = (width, height) => {
		return (
			<div style={{ position: 'absolute', width: width, height: height - (width / 2), bottom: 0, left: 0, backgroundColor: '#424958', zIndex: 99 }} />
		)
	}

	render() {

		let links = [];
		let viewConfig = {
			list_offset: this.props.screen.r16_9.left + this.props.screen.r16_9.p10 * 3,
			list_width: this.props.screen.r16_9.width - this.props.screen.r16_9.p10 * 3,
		}
		_.map(this.state.donorsGrouped, (group) => {
			links.push({ name: group.name, navroute: null })
		})

		let modalBorderV = .035 * this.props.screen.screenHeight;
		let modalBorderH = .02 * this.props.screen.r16_9.width;
		let navarea = this.navarea(this.props.screen.r16_9.width - (modalBorderH * 2), this.props.screen.screenHeight - (modalBorderV * 2))

		this._refCounter = 0;
		return (
			<div>
				<div style={{ position: 'absolute' }}>
					<div style={{ zIndex: 10, width: '100vw', height: '100vh' }}>
						<div style={{ position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 }}>

						</div>
						<div style={{ position: 'absolute', left: this.props.screen.r16_9.left, top: this.props.screen.r16_9.p10 * 2 }}>
							<LinkListChicago fontClass={this._fontClass} selectedLinkIndex={this.state.selectedLinkIndex} screen={this.props.screen} links={links} switchCategory={this.switchCategory} colorInactive={'#496778'} />
						</div>
						
						<div style={{ position: 'absolute', left: viewConfig.list_offset, backgroundColor: '#496778', width: viewConfig.list_width, height: this.props.screen.screenHeight, touchAction:"none" }}>
							{this.state.donorsGrouped.length>0?
							<ReactIScroll ref={el => this.scrollRef[0] = el} iScroll={iScroll}
								options={{
									scrollX: false,
									scrollY: true,
									probeType: 2,
									disableTouch: false,
									disablePointer: false,
									disableMouse: false,
									momentum: true,
									deceleration: 0.01,
									tap: true,
									mouseWheel: true,
									useTransition: true
								}}
								onScrollEnd={this.onScrollEnd}
								onRefresh={this.initializeDonorRefs}
							>

								<div>
									{this.renderDonorCategories()}
									<div style={{ display: 'inline-block', width: '100%', height: this.props.screen.screenHeight * .15 }} />
								</div>
							</ReactIScroll>
							:
							null}
						</div>

					</div>
				</div>
				<CSSTransitionGroup
					component='div'
					transitionName='example'
					transitionEnterTimeout={0}
					transitionLeaveTimeout={0}>
					<div key={this.state.showStory}>
						{this.state.showStory ?
							<div>
								<div style={{ position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height, backgroundColor: 'black', opacity: .5 }} />
								<div style={{ pointerEvents: 'none', position: 'absolute', left: modalBorderH + this.props.screen.r16_9.left, width: this.props.screen.r16_9.width - (modalBorderH * 2), height: this.props.screen.screenHeight - (modalBorderV * 2), top: modalBorderV, backgroundColor: 'white', zIndex: 100 }}>
									{navarea}
								</div>
							</div>
							:
							<span />
						}
					</div>
				</CSSTransitionGroup>
				<div style={{ zIndex: 100, position: 'fixed', pointerEvents: 'none', top: 0, left: this.props.screen.r16_9.left, width: this.props.screen.r16_9.width, height: this.props.screen.sv.height }}>
					{/* Screen 2 Slides */}
					<CSSTransitionGroup
						component='div'
						transitionName='example'
						transitionEnterTimeout={0}
						transitionLeaveTimeout={0}>
						<div key={this.state.story.id}>
							{this.state.showStory ?
								<div>
									{/* split this out to seperate transition that is ONLY based on showStory or not */}

									<StoryChicagoModal
										fontClass={this._fontClass}
										closeStory={this.closeStory}
										contextualheader={this.state.story.contextualheader}
										headline={this.state.story.headline}
										subtitle={this.state.story.subtitle}
										body={this.state.story.body}
										quote={this.state.story.quote}
										mainimage={this.state.story.mainimage}
										slickAssets={this.state.story.slickAssets}
										left={modalBorderH}
										top={modalBorderV}
										width={this.props.screen.r16_9.width - (modalBorderH * 2)}
										height={this.props.screen.screenHeight - (modalBorderV * 2)}
										zIndex={100}
										cycleStory={this.cycleStory}
										showQuotes={this.state.story.showQuotes}
									/>
								</div>
								:
								<span />}
						</div>
					</CSSTransitionGroup>
				</div>
			</div>
		)
	}




}

const mapStateToProps = (state) => {
	return {
		module: state.content.dm_active[state.active_module],
		screen: state.screen,
		donors: state.donors
	};
};

export default connect(mapStateToProps, null)(DonorListChicago);



// WEBPACK FOOTER //
// ./src/Components/Theme/Chicago/DonorListChicago.js